import { useEffect } from 'react';
import { useStore, useStoreActions, useStoreStatic } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { defaultFeatureFlagsKey } from '~/store/store.utils';
const FETCH_RETRY_DELAY_MS = 3000;
/** Automatically fetches feature-flags for the relevant businessId, if they weren't already fetched. */ export function useFeatureFlagsFetcher() {
    let retryDelayMs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : FETCH_RETRY_DELAY_MS;
    const { ff: { fetchFeatureFlags } } = useStoreActions();
    const businessId = useStore(selectors.ff.ffBusinessId);
    const fetchError = useStore((state)=>selectors.ff.featureFlags(state).error);
    const { getState } = useStoreStatic();
    useEffect(()=>{
        // Check the actual target feature flags directly (not through selector with fallback)
        const targetBusinessId = businessId || defaultFeatureFlagsKey;
        const targetFF = getState().ff.featureFlags[targetBusinessId];
        // Only fetch if the target FF doesn't exist, isn't loading, and has no error
        if (!targetFF || targetFF.data === null && !targetFF.loading && !targetFF.error) {
            fetchFeatureFlags(businessId);
        }
    }, [
        businessId
    ]);
    useEffect(()=>{
        if (fetchError != null) {
            const retryTimer = setInterval(()=>fetchFeatureFlags(businessId), retryDelayMs);
            return ()=>clearInterval(retryTimer);
        }
    }, [
        fetchError,
        businessId,
        retryDelayMs
    ]);
}
